import {Injectable} from '@angular/core';

import {CacheCollection, CacheItem} from '../classes';

@Injectable({
    providedIn: 'root'
})
export class CacheCollectionService {
    protected cacheCollection: CacheCollection;

    constructor() {
        this.cacheCollection = new CacheCollection();
    }

    addItem(key: string, data: any) {
        this.cacheCollection.addItem(key, data);
    }

    hasItem(key: string): boolean {
        return this.cacheCollection.hasItem(key);
    }

    getItem(key: string): CacheItem {
        return this.cacheCollection.getItem(key);
    }

    removeItem(key: string): void {
        this.cacheCollection.removeItem(key);
    }

    flush() {
        this.cacheCollection.flush();
    }
}
